export const toBase64 = (file: any): Promise<{ url: string | ArrayBuffer | null; type: 'image' | 'video' | null }> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => {
      // @ts-ignore
      const [, type] = reader.result?.match(/^data:([^/]+)\/([^;]+);/) || [];
      resolve({ url: reader.result, type });
    };
    reader.onerror = (error) => reject(error);
  });

export const bytesToMB = (bytes: number): number => bytes / 1024 / 1024;
